import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	contactsHeader: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		gap: theme.spacing(2),
		flexWrap: "wrap",
		padding: 0,
		marginBottom: theme.spacing(1),
		minHeight: 44,
		"& > *:first-child": {
			minWidth: 0,
		},
		[theme.breakpoints.down("xs")]: {
			flexDirection: "column",
			alignItems: "stretch",
		},
	},
}));

const MainHeader = ({ children, className = "" }) => {
	const classes = useStyles();

	return <div className={`${classes.contactsHeader} ${className}`}>{children}</div>;
};

export default MainHeader;
